export default function InputField({
	label,
	type = "text",
	placeholder,
	value,
	onChange,
	errorMsg,
	inputClass,
	controlClass,
	disabled,
	accept,
	...props
}) {
	function handleChange(e) {
		onChange(e.target.value);
	}

	return (
		<div className="mb-4">
			<label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
			<div className={`relative ${controlClass}`}>
				<input
					className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 ${inputClass}`}
					type={type}
					placeholder={placeholder}
					onChange={handleChange}
					value={value}
					disabled={disabled}
					accept={accept}
					{...props}
				/>
			</div>
			{errorMsg && <p className="mt-2 text-sm text-red-600">{errorMsg}</p>}
		</div>
	);
}
